import { ref } from 'vue'

export function useFormValidation() {
  const errors = ref<Record<string, string>>({})

  const validateRequired = (value: string, fieldName: string): boolean => {
    if (!value || !value.trim()) {
      errors.value[fieldName] = `${fieldName.replace(/_/g, ' ')} is required`
      return false
    }
    delete errors.value[fieldName]
    return true
  }

  const validateEmail = (value: string): boolean => {
    if (!value || !value.trim()) {
      delete errors.value.email
      return true
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(value.trim())) {
      errors.value.email = 'Please enter a valid email address'
      return false
    }
    delete errors.value.email
    return true
  }

  const validateFirstName = (firstName: string | undefined): boolean => {
    return validateRequired(firstName || '', 'first_name')
  }

  const validateLastName = (lastName: string | undefined): boolean => {
    return validateRequired(lastName || '', 'last_name')
  }

  const setError = (field: string, message: string): void => {
    errors.value[field] = message
  }

  const setGeneralError = (message: string): void => {
    errors.value.general = message
  }

  const clearError = (field: string): void => {
    delete errors.value[field]
  }

  const clearAllErrors = (): void => {
    errors.value = {}
  }

  return {
    errors,
    validateRequired,
    validateEmail,
    validateFirstName,
    validateLastName,
    setError,
    setGeneralError,
    clearError,
    clearAllErrors,
  }
}
